import React from 'react';

const BackButtonIcon = ({ color = '#4A4A4A' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.8 7L9.4 1.4L8 0L0 8L8 16L9.4 14.6L3.8 9H16V7H3.8Z"
      fill={color}
    />
  </svg>
);

export default BackButtonIcon;
